import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailPageLayout, { DetailSection } from '../utils/DetailPageLayout';

function SinglePhotoContent(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const url = `${process.env.REACT_APP_API_BASE_URL}/api/photos/${id}`;

  useEffect(() => {
    setIsLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => setHasError(err))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (isLoading) {
    return (
      <>
        <div className="detail-page"><p>Loading...</p></div>
      </>
    );
  }

  if (hasError || !data) {
    return (
      <>
        <div className="detail-page"><p>Could not load this photo.</p></div>
      </>
    );
  }

  const meta = [];
  if (data.Country) meta.push({ label: 'Location', value: data.Country });

  const imgUrl = data.Filename ? `${process.env.REACT_APP_API_BASE_URL}/img/photos/${data.Filename}` : null;

  return (
    <>
      <DetailPageLayout
        eyebrow="Photo"
        title={data.Description || 'Untitled Photo'}
        meta={meta}
      >
        {imgUrl && (
          <DetailSection title="Image">
            <img src={imgUrl} alt={data.Description || 'Photo'} />
          </DetailSection>
        )}

        {data.Notes && (
          <DetailSection title="Notes">
            <p>{data.Notes}</p>
          </DetailSection>
        )}

        {(data.SourceName || data.SourceUrl) && (
          <DetailSection title="Source">
            <p>
              {data.SourceName}
              {data.SourceUrl && (
                <>
                  {data.SourceName ? ' — ' : ''}
                  <a href={data.SourceUrl} target="_blank" rel="noopener noreferrer">{data.SourceUrl}</a>
                </>
              )}
            </p>
          </DetailSection>
        )}
      </DetailPageLayout>
    </>
  );
}

export default SinglePhotoContent;
